// extracted by mini-css-extract-plugin
export var attachment = "_lv-a";
export var emailContainer = "_lv-4";
export var emailContentPaddedContainer = "_lv-b";
export var emailHeader = "_lv-6";
export var emailIframe = "_lv-3";
export var emailInfoIcon = "_lv-9";
export var emailShortenedSummary = "_lv-e";
export var infoDropdown = "_lv-0";
export var infoRowBoundedContent = "_lv-d";
export var internal = "_lv-5";
export var merchant = "_lv-8";
export var messageInputContainer = "_lv-h";
export var normal = "_lv-7";
export var replyCard = "_lv-f";
export var subtleButton = "_lv-1";
export var subtleButtonIconContainer = "_lv-2";
export var toggleViewRepliesButton = "_lv-c";
export var wrappingText = "_lv-g";